<template>
	<div class="hwit homework__item">
		<div class="hwit__top">
			<div class="homework__date"><span class="ico-calendar" uk-tooltip="Дата создания"></span>
				<span>{{ reDate(item.created_at) }}</span></div>

			<div class="homework__date hwit__dates" v-if="item.string_dates">
				<span class="ico-calendar" uk-tooltip="Даты домашнего задания"></span>
				<span>{{ item.string_dates }}</span>
			</div>
		</div>

		<!--Настройки-->
		<div class="homework__content">
			<div class="hwit__wrap">
				<div class="homework__title">
					Настройки тренажера / Описание:
					<small>
						<span class="uk-badge" uk-tooltip="Количество повторов" v-if="item.trainer_id">{{ item.qnt }}</span>

						<span uk-tooltip="Направление" class="uk-badge" v-if="typeof item.params.direct !== 'undefined'">{{ item.params.direct ? 'Прямое' : 'Обратное' }}</span>

						<span uk-tooltip="Описание" class="hwit__desc" v-if="typeof item.params.desc !== 'undefined'">{{ item.params.desc }}</span>

						<span uk-tooltip="Размер поля" class="uk-badge" v-if="item.params.size">{{ item.params.size }} x {{ item.params.size }}</span>

						<span uk-tooltip="Формула" class="uk-badge" v-if="typeof item.params.formula !== 'undefined'">
									<i v-if="item.params.formula == '0'">Прямой</i>
									<i v-else-if="item.params.formula == '5'">5-ки</i>
									<i v-else-if="item.params.formula == '10'">10-ки</i>
									<i v-else-if="item.params.formula == '10-5'">5-ки и 10-ки</i>
									<i v-else-if="item.params.formula == '15'">Комбо</i>
									<i v-else-if="item.params.formula == '*'">Микс</i>
								</span>

						<span uk-tooltip="Режим" class="uk-badge" v-if="item.params.mode">{{ item.params.mode === 'train' ? 'Трен' : 'Исп' }}</span>

						<span uk-tooltip="Тип" class="uk-badge" v-if="item.params.type">{{ item.params.type === 'multi' ? 'Умножение' : 'Деление' }}</span>

						<span uk-tooltip="Тип" class="uk-badge" v-if="typeof item.params.direction !== 'undefined'">{{ item.params.direction ? 'Ч -> А' : 'А -> Ч' }}</span>

						<span uk-tooltip="Слагаемых" class="uk-badge" v-if="typeof item.params.terms !== 'undefined'">{{ item.params.terms }}</span>

						<span uk-tooltip="Числа" class="uk-badge" v-if="typeof item.params.rank !== 'undefined'">от {{ split(item.params.rank, '/')[0] }} до {{ split(item.params.rank, '/')[1] }}</span>

						<span uk-tooltip="Количество осей" class="uk-badge" v-if="item.trainer && item.trainer.component == 'flash'">{{ item.params.to }}</span>


						<span uk-tooltip="Разряды" class="uk-badge" v-if="typeof item.params.first !== 'undefined'"> {{ item.params.first.digits }}, {{ item.params.second.digits }}</span>

						<span uk-tooltip="Скорость, сек" class="uk-badge" v-if="item.params.speed && item.trainer.component !== 'columns'">
									<i v-if="item.trainer_id !== 5">{{ isInt(item.params.speed) }}</i>
									<i v-else-if="item.trainer_id === 5">{{ item.params.mode == 'train' ? 'Нет' : isInt(item.params.speed) }}</i>
								</span>
					</small>
				</div>
				<div class="hwit__right">
					<div class="hwit__students">
						<small>Ученики:</small>
						<span>{{ users }}</span>
					</div>
				</div>
				<!--<div class="homework__params homework__params&#45;&#45;students">
					<small>Ученики:</small>
				</div>-->
			</div>
		</div>

	</div>
</template>

<script>
  import moment from "moment";
  import swal from "sweetalert";

  export default {
    name: "hw-arc-item",
    props: {
      item: ''
    },
	  computed: {
      users(){
        let arc = [];
        _.forEach(this.item.students, function (e) {
          arc.push(e.name);
        });
	      arc = _.uniq(arc);
        return arc.join(', ');
      }
	  },
    methods: {
      reDate(date) {
        if (date) {
          return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
        }
      },
      /** Возвращаем дробное число */
      isInt(val) {
        if (Number.isInteger(val)) {
          return val + '.0';
        } else {
          return val;
        }
      },
      /** Split */
      split(str, razd) {
        return str.split(razd);
      },
    }
  }
</script>